<template>
<footer class="bg-gray-900 text-white pt-16 pb-8">
  <div class="container mx-auto px-6">
    <div class="flex flex-col md:grid md:grid-cols-4 gap-8 mb-8">
      <div class="mb-8 md:mb-0 text-center md:text-left hidden md:block">
        <h3 class="text-xl font-semibold mb-4">关于我们</h3>
        <p class="text-gray-400 mb-4">AI定制服务网站，为您提供个性化的产品定制解决方案，让创意成为现实。</p>
        <div class="flex justify-center md:justify-start space-x-4">
          <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
            <i class="fab fa-weixin text-xl"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
            <i class="fab fa-weibo text-xl"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
            <i class="fab fa-instagram text-xl"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
            <i class="fab fa-tiktok text-xl"></i>
          </a>
        </div>
      </div>
      <div class="mb-8 md:mb-0 text-center md:text-left">
        <h3 class="text-xl font-semibold mb-4">快速链接</h3>
        <ul class="space-y-2">
          <li><router-link to="/" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">首页</router-link></li>
          <li><router-link to="/mall" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">作品商城</router-link></li>
          <li><router-link to="/category-list" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">定制分类</router-link></li>
          <li><router-link to="/about-us" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">关于我们</router-link></li>
          <li><router-link to="/about-us" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">联系我们</router-link></li>
        </ul>
      </div>
      <div class="mb-8 md:mb-0 text-center md:text-left hidden md:block">
        <h3 class="text-xl font-semibold mb-4">帮助中心</h3>
        <ul class="space-y-2">
          <li><a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">常见问题</a></li>
          <li><a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">定制流程</a></li>
          <li><a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">退换货政策</a></li>
          <li><a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">隐私政策</a></li>
          <li><a href="#" class="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">用户协议</a></li>
        </ul>
      </div>
      <div class="text-center md:text-left">
        <h3 class="text-xl font-semibold mb-4">联系方式</h3>
        <ul class="space-y-2">
          <li class="flex items-center justify-center md:justify-start">
            <i class="fas fa-map-marker-alt mr-2 text-[#76B900]"></i>
            <span class="text-gray-400">北京市朝阳区裕民路12号1号楼11层</span>
          </li>
          <li class="flex items-center justify-center md:justify-start">
            <i class="fas fa-phone-alt mr-2 text-[#76B900]"></i>
            <span class="text-gray-400">13810005010</span>
          </li>
          <li class="flex items-center justify-center md:justify-start">
            <i class="fas fa-envelope mr-2 text-[#76B900]"></i>
            <span class="text-gray-400">168787363@qq.com</span>
          </li>
          <li class="flex items-center justify-center md:justify-start">
            <i class="fas fa-clock mr-2 text-[#76B900]"></i>
            <span class="text-gray-400">周一至周日 9:00-18:00</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="border-t border-gray-800 pt-8 mt-8">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <p class="text-gray-400 text-sm mb-4 md:mb-0">© 2025 AI定制服务网站. 保留所有权利.</p>
        <div class="flex space-x-4">
          <i class="fab fa-alipay text-2xl text-gray-400"></i>
          <i class="fab fa-weixin text-2xl text-gray-400"></i>
          <i class="fab fa-cc-visa text-2xl text-gray-400"></i>
          <i class="fab fa-cc-mastercard text-2xl text-gray-400"></i>
          <i class="fab fa-paypal text-2xl text-gray-400"></i>
        </div>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'FooterBar',
}
</script> 